import { API_URL } from "env";

export interface PromotionProduct {
    promotion_id: number;
    product_id: number;
    percent: number;
    product: {
        id: number;
        name: string;
        slug: string;
        product_category_id: number;
        price: number;
        discount: number;
        avatar: string;
        is_active: boolean;
        is_highlight: boolean;
        short_content: string;
        list_thumbnail: string;
        position: number;
        translation: string;
        star: number;
        is_stock: boolean;
        ingredients: string;
        indications: string;
        contraindications: string;
        dosage: string;
        drug_interactions: string;
        storage: string;
        overdose: string;
        is_limit: number;
        is_new: number;
        is_follow: number;
        alt: string;
    }
}

export interface PromotionItem {
    id: number;
    name: string;
    slug: string;
    avatar?: string;
    start_date: string;
    end_date: string;
    description: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    promotion_product: PromotionProduct[]
}

export interface ListPromotion {
    status: boolean;
    data: {
        total: number;
        current_page: number;
        items: PromotionItem[]
    }
}

async function getProductListPromotion(page: number, limit: number) {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await fetch(`${API_URL}/api/v1/fe/promotions?page=${page}&limit=${limit}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching product list promotion:", error);
        throw error;
    }

}

async function getLastedCurrentPromotionProducts(): Promise<ListPromotion> {
    try {

        const query = new URLSearchParams();
        query.append('sort[]', 'start_date,desc');
        query.append('limit', '100');

        const response = await fetch(`${API_URL}/api/v1/fe/promotions?${query.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching lasted current promotion products:", error);
        throw error;
    }
}

export { getProductListPromotion, getLastedCurrentPromotionProducts };